var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show && _vm.remoteDatasetLoaded)?_c('BaseTeaser',_vm._b({class:_vm.widthClass,attrs:{"id":_vm.anchorName,"teaser-variant":_vm.teaserVariant,"data-t-name":"teaser_rc_event"}},'BaseTeaser',_vm.teaserData,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }